













import Vue from 'vue'
import DocumentationsItem from '@/UI/Auction/Documentations/DocumentationsItem.vue'
import { DocumentationsData } from '@/Infrastructure/Store/Auction/DocumentationsData'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import { MessageAlert } from '@/Domain/MessageAlert'

export default Vue.extend({
  name: 'DocumentationsForm',
  components: {
    DocumentationsItem
  },
  props: {
    previusDocumentationData: {
      type: Array as () => DocumentationsData[],
      required: true
    },
    selectedUsertype: {
      type: Array,
      required: true
    },
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  methods: {
    filterDocumentationById (typology: number): DocumentationsData {
      const documentation = this.previusDocumentationData.find(current => current.idItem === typology)
      const emptyDocumentationData = {
        idItem: typology,
        file: '',
        organo: '',
        codProcedemento: '',
        ano: '',
        checked: false,
        presentada: false,
        alreadyInCorpu: false
      }
      return documentation === undefined ? emptyDocumentationData : documentation
    },
    onDocumentationItemUploadError ($event: string) {
      EventBus.$emit('messageAlert', new MessageAlert($event, 'error'))
    }
  }
})
